import { cx } from '@eti/styles';
import { useAsset } from '../../custom-hooks/asset';
import { AssetType } from '../../custom-hooks/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const generateStyle = (color, height, width, top) => ({
  ...(color ? {
    fill: color
  } : {}),
  ...(height ? {
    height
  } : {}),
  ...(width ? {
    width
  } : {}),
  ...(top ? {
    marginTop: top
  } : {})
});
const Icon = _ref => {
  let {
    children,
    className,
    color,
    isGraphic = false,
    height,
    id,
    onClick,
    width,
    size,
    top,
    ...rest
  } = _ref;
  const {
    ReactComponent
  } = useAsset(AssetType.Icon, id);
  const reactComponentProps = {
    pointerEvents: 'all',
    'aria-hidden': isGraphic ? undefined : 'true',
    className: cx('etiIcon', className),
    onClick,
    role: isGraphic ? 'img' : 'presentation',
    style: generateStyle(color, height || size, width || size, top),
    ...rest
  };
  return ReactComponent ? /*#__PURE__*/_jsx(ReactComponent, {
    ...reactComponentProps,
    children: children
  }) : /*#__PURE__*/_jsx("div", {});
};
export default Icon;
//# sourceMappingURL=Icon.js.map